import React, { type FC } from 'react'

import classes from './VideoInfo.module.scss'

type VideoInfoProps = {
  title: string
}

export const VideoInfo: FC<VideoInfoProps> = ({ title }) => {
  return <div className={classes.Title}>{title}</div>
}
